export default __webpack_public_path__ + "static/media/choosetolove.0a3e5907.gif";